import { Box, Button } from "@mui/material";

import { getPageName } from "constants/trackingProps";
import { trackEvent } from "utils/tracking";

const CloseDealButton = () => {
  const trackClick = () => {
    trackEvent("How To Close Deal Button Clicked", {
      Source: getPageName(),
    });
  };

  return (
    <Button
      disableElevation
      variant="contained"
      sx={{
        textTransform: "none",
        backgroundColor: "yellow.main",
        ml: -2,
        color: "black",
        borderBottomRightRadius: 20,
        borderTopRightRadius: 0,
        "&:hover": {
          backgroundColor: "yellow.light",
        },
      }}
      href={`https://www.notion.so/hatchways/How-to-Close-a-Brand-Deal-1cb8dbc98c0680e38324d28701dd2f5d?pvs=4`}
      onClick={trackClick}
      target="_blank"
    >
      💡 How To Close Brand Deals{" "}
      <Box
        sx={{ ml: 1 }}
        component="i"
        className="fa-regular fa-arrow-up-right-from-square"
      />
    </Button>
  );
};

export default CloseDealButton;
